<div class="team-reports">

  <div class="filters">
    <div class="filter" [ngClass]="{'active': selectedFilter === 'week'}"
         (click)="onChangeFilter('week')">
      <span>week v last</span>
    </div>
    <div class="filter" [ngClass]="{'active': selectedFilter === 'month'}"
         (click)="onChangeFilter('month')">
      <span>month v last</span>
    </div>
    <div class="filter" [ngClass]="{'active': selectedFilter === 'year'}"
         (click)="onChangeFilter('year')">
      <span>year v last</span>
    </div>
    <div class="filter" [ngClass]="{'active': selectedFilter === 'custom'}">
      <span>
        <span class="hidden-overlay" (click)="selectedFilter = 'custom'"
              *ngIf="selectedFilter !== 'custom'"></span>
        <form (submit)="updateReports('custom')">
          from:
          <p-calendar class="primeng-date" [(ngModel)]="fromDate"
                      [maxDate]="currentDate" readonlyInput="true"
                      placeholder="05/05/2018" dateFormat="dd/mm/yy" name="fromDate"
                      [disabled]="selectedFilter !== 'custom'"></p-calendar>
          to:
          <p-calendar class="primeng-date" [(ngModel)]="toDate"
                      [minDate]="fromDate" [maxDate]="currentDate" readonlyInput="true"
                      placeholder="05/07/2018" dateFormat="dd/mm/yy" name="toDate"
                      [disabled]="selectedFilter !== 'custom'"></p-calendar>
          <input aria-label=""  type="submit" class="app-submit" value="Search"
                 [disabled]="fromDate === null || toDate === null
                 || selectedFilter !== 'custom'">
        </form>
      </span>
    </div>
  </div>

  <div class="reports-content">
    <div class="report-titles">
      <h2>{{teamName}}'s team performance</h2>
      <h3>{{dateRangeText}}</h3>  
    </div>
    
    <div class="reports-table">
      
      <div [ngStyle]="{'opacity': loadingState ? '0' : '1'}">
        <reports-table [teamsReport]="teamReport" [dateRangeText]="dateRangeText"
                       [totalTeamsReport]="totalTeamReport"></reports-table>
      </div>
    </div>

    <div class="download-btns">
      <button class="app-submit secondary" (click)="downloadDocument('pdf')">
        PDF&nbsp;&nbsp;
        <img [src]="constants.assetsPath + '/img/icons/download-white.svg'" width="14">
      </button>
      <button class="app-submit secondary" (click)="downloadDocument('excel')">
        EXCEL&nbsp;&nbsp;
        <img [src]="constants.assetsPath + '/img/icons/download-white.svg'" width="14">
      </button>
    </div>

  </div>

</div>
